import {Component} from '@angular/core';
import {ModalService} from "../../../../services/modal.service";

@Component({
  selector: 'app-delete-payment-success-dialog',
  templateUrl: './delete-payment-success-dialog.component.html',
  styleUrls: ['./delete-payment-success-dialog.component.scss']
})
export class DeletePaymentSuccessDialogComponent {


  constructor(
    private modalService: ModalService
  ) {
  }

  goToRoleList() {
    this.modalService.closeModal()
  }
}
